import { useState } from 'react';
import { ChatIcon } from 'tdesign-icons-react';
import { Drawer, StickyTool } from 'tdesign-react';
import { AttachNode } from 'tdesign-react/es/common';
import StickyItem from 'tdesign-react/es/sticky-tool/StickyItem';

import { HeaderPhoneIcon } from './icon/headerPhone';
import styles from './index.module.less';

interface IProps {
  children: React.ReactNode;
  bgImage?: string;
  mode?: 'drawer' | 'inner';
  node?: AttachNode;
}

/**
 * 预览抽屉组件
 */
const PreviewDrawer = ({ children, bgImage, mode = 'drawer', node }: IProps) => {
  const [visible, setVisible] = useState(false);

  const triggerClick = () => {
    setVisible(!visible);
  };

  const previewDom = (
    <div className={styles.previewWrapper}>
      <div className={styles.headerWrapper}>
        <div className={styles.header}>
          <HeaderPhoneIcon />
          <span className={styles.tip}>最终效果以实际展现为准</span>
        </div>
      </div>
      <div className={styles.imageContent}>
        <div className={styles.bgImageWrap}>
          <div
            className={styles.backgroundImage}
            style={{ backgroundImage: `url(${bgImage})` }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );

  const previewDom2 = (
    <div className={styles.previewWrapper}>
      <div className={styles.headerWrapper}>
        <div className={styles.header}>
          <HeaderPhoneIcon />
          <span className={styles.tip}>最终效果以实际展现为准</span>
        </div>
      </div>
      <div
        className={styles.imageContent}
        style={{
          width: 'calc((100vh - 128px) * 9 / 20)',
          height: 'calc(100vh - 128px)',
        }}
      >
        <div className={styles.bgImageWrap}>
          <div
            className={styles.backgroundImage}
            style={{ backgroundImage: `url(${bgImage})` }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      {mode === 'drawer' && (
        <>
          <StickyTool
            className={styles.sticky}
            onClick={triggerClick}
            style={{ zIndex: 9 }}
          >
            <StickyItem label='效果预览' icon={<ChatIcon />}></StickyItem>
          </StickyTool>
          <div className={styles.preview}>{previewDom}</div>
          <Drawer
            visible={visible}
            onClose={triggerClick}
            header={false}
            footer={false}
            size={'447px'}
            attach={node}
            style={{ display: 'flex', alignItems: 'center', padding: 0 }}
            destroyOnClose
          >
            {previewDom2}
          </Drawer>
        </>
      )}
      {mode === 'inner' && <div className={styles.preview}>{previewDom}</div>}
    </div>
  );
};

export default PreviewDrawer;
